import React from 'react';
import { connect } from 'react-redux';

import { selectPathname, selectSearchParams } from '../../redux/router/selectors';

import AuthFormLinks from './AuthFormLinks';

const AuthFormLinksConnected = (props) => <AuthFormLinks {...props} />;

const mapStateToProps = (state) => ({
  pathname: selectPathname(state),
  searchParams: selectSearchParams(state),
});

export default connect(mapStateToProps)(AuthFormLinksConnected);
